// src/lib/BaseCalloutPlugin.ts
import { bindFirst, createSlatePlugin } from "@udecode/plate";

// src/lib/transforms/insertCallout.ts
var CALLOUT_STORAGE_KEY = `plate-storage-callout`;
var insertCallout = (editor, {
  icon,
  variant,
  ...options
} = {}) => {
  editor.tf.insertNodes(
    {
      children: [{ text: "" }],
      icon: icon ?? localStorage.getItem(CALLOUT_STORAGE_KEY) ?? "\u{1F4A1}",
      type: editor.getType(BaseCalloutPlugin),
      variant
    },
    options
  );
};

// src/lib/BaseCalloutPlugin.ts
var BaseCalloutPlugin = createSlatePlugin({
  key: "callout",
  node: { isElement: true }
}).extendEditorTransforms(({ editor }) => ({
  insert: { callout: bindFirst(insertCallout, editor) }
}));
export {
  BaseCalloutPlugin,
  CALLOUT_STORAGE_KEY,
  insertCallout
};
//# sourceMappingURL=index.mjs.map